import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import { Typography, Grid } from "@mui/material";
import RootPage from "../RootPage";
import localisations from "../../shell/localisation";
import { PartitionTable } from "../../domains/partitions/components";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router";
import RoutePaths from "../../routes/route-paths";
import { guid } from "domains/partitions/services/partition-service";
import { useAuth0 } from "@auth0/auth0-react";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import { useLayoutEffect } from "react";

function PartitionsPage() {
    const {
        partitions: { heading, blurb },
    } = localisations.pages;

    const history = useHistory();

    const rowClickNavigation = (partitionId: guid) => {
        history.push(generatePath(RoutePaths.ShowPartition, { id: partitionId }));
    };

    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    useLayoutEffect(() => {
        //Clear search only for menu click
        if (history.location.pathname === RoutePaths.Partitions && history.action !== "POP") {
            localStorage.removeItem("searchDetails");
        }
    }, []);

    return (
        <RootPage header={heading}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                        {blurb}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <PartitionTable fieldCompanyId={fieldCompanyId} onRowClick={rowClickNavigation} />
                </Grid>
            </Grid>
        </RootPage>
    );
}

export default withAITracking(reactPlugin, PartitionsPage, "Partitions Page");
